import { isTypeProgramsPageHeader } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulProgramsPageHeader = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeProgramsPageHeader(entry)) {
    return null;
  }

  return <div>ContentfulProgramsPageHeader</div>;
};

export default ContentfulProgramsPageHeader;
